import moment from 'moment';



 


        class Dashboard{
         constructor(params,o,cb=false){
          this.id = o.id;
          this.cb = cb;
          this.accountType = "Dashboard";
            this._types = {}
          this.generic = {
            name:"",
            subTitle:"",
            description:"",
            id:"",
            platformId:"",
            accountType:"",
            image:"",
            url:false,
            status:"",
            category:"",
            createdAt:"",
            updatedAt:"",
          }
          this.setParameters(o,params.permissionsTable);
               

          for (var t of  Object.keys(this._types)){
           if (params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
             for (var pt of params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
               if (pt.objectIds.indexOf(this.id) > -1){
                 for (var oid of pt.pivotObjectIds){
                   if ((params.accounts[pt.pivotAccountId] && params.accounts[pt.pivotAccountId][oid]) && (!this.filter || (this.filter && this.filter[pt.pivotAccountId] && this.filter[pt.pivotAccountId].indexOf(oid) > -1))) {
                      params.accounts[pt.pivotAccountId][oid].filter = this.filter;
                   var model = new this._types[t](params,params.accounts[pt.pivotAccountId][oid]);
                   this.setModelParameters(model);
                   }
                 }
               }
           }
         }
         }
         
 }



           setParameters(params,pt){
             for (var prop in params){
                 if (params.hasOwnProperty(prop)){
                     var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
                     if (this[method]){
                      this[method](params[prop]);
                    }
                    else{
                     this[prop] = params[prop];
                    }
                     
                 }
             }
             this.setUrl();
             if (pt["Useraccount-Dashboard"]){
            pt["Useraccount-Dashboard"].map((ud) => {if (ud.roleIds.indexOf("owner") > -1 && this.id == ud.id){this.setOwnerOf()}})
             }
             if (this.name == ""){
              this.generic.name = this.domain.charAt(0).toUpperCase() + this.domain.slice(1) + " - " + this.dashboardType;
             }
         }

         setDashboardSettings(str){
          this.dashboardSettings = JSON.parse(str);
         }
           
         setId(id){
             this.id = id;
             this.generic.id = id;
       }

       setDomain(str){
        this.generic.name = str.charAt(0).toUpperCase()+str.slice(1) + this.generic.name;
        this.domain = str;
       }

       setOwnerOf(){
        this.isOwner = true;
       }
       setUrl(){
        var dashperms = [];
        if (this.domain == "network"){
          
        }else{
          dashperms.push(this.domain);
            var url = this.dashboardType;
            dashperms.push(url);
            var urlParts = this.dashboardType.split("-");
            urlParts.map((p) => {
              dashperms.push(p);
            })
        }
        if (this.cb){
        this.cb(dashperms);
        }
       }

       setName(str){
        this.generic.name = str;
        this.name = str;
       }

       setFullName(str){
        this.generic.name = (str && str != "adf") ? str : this.generic.name;
       }
       setDashboardType(str){
        
        this.dashboardType = str;
       }
         setAccountType(val){
          this.accountType = "Dashboard";
         }
         

         
     
       
     
     setModelParameters(params){
         this[params.accountType] = (this[params.accountType]) ? this[params.accountType] : [];
         this[params.accountType].push(params);
     }
   }
        export default Dashboard;
                  